// Single source of truth for the marketing component registry.
// Imported by BOTH the client pack (marketing-bundle.js) and the server pack
// (server-bundle.js) so the same names hydrate on the client and prerender on
// the server. The global stylesheet is imported here so it is extracted into
// the marketing-bundle stylesheet for the client build.
import './styles/tailwind.css';

import Home from './components/pages/Home';
import About from './components/pages/About';
import Pricing from './components/pages/Pricing';
import Contact from './components/pages/Contact';
import FeaturedShops from './components/pages/FeaturedShops';
import Terms from './components/pages/Terms';
import ThankYou from './components/pages/ThankYou';
import Blog from './components/pages/Blog';
import BlogPost from './components/pages/BlogPost';
import HelpCenter from './components/pages/HelpCenter';
import HelpArticle from './components/pages/HelpArticle';

const marketingComponents = {
  MarketingHome: Home,
  MarketingAbout: About,
  MarketingPricing: Pricing,
  MarketingContact: Contact,
  MarketingFeaturedShops: FeaturedShops,
  MarketingTerms: Terms,
  MarketingThankYou: ThankYou,
  MarketingBlog: Blog,
  MarketingBlogPost: BlogPost,
  MarketingHelpCenter: HelpCenter,
  MarketingHelpArticle: HelpArticle,
};

export default marketingComponents;
